import styled from 'styled-components';
import { StatusHistoricProps } from '../../common/interfaces';
import { HistoricOccurrenceColor } from '../../components/enum/historicOccurrenceEnum';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    SearchCard as ProductSearchCard,
} from '../sharedTable.styled';

export const StatusCell = styled.td<StatusHistoricProps>`
  color: ${({ status }) => HistoricOccurrenceColor[status] || 'var(--text)'};
  font-weight: 700;
`;
